export function hasStatus(x: unknown): x is { status: number } {
  return Boolean(
    typeof x === 'object' && x && 'status' in x && typeof x.status === 'number'
  )
}
